// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/WelcomeMessage/index.css
// module id = 489
// module chunks = 0